import { handleActions } from 'redux-actions';
import { GET_MEDICATIONS_BY_COUNTRY } from '../constants/get';

export const MedicamentosPais = handleActions ({
    [GET_MEDICATIONS_BY_COUNTRY]: (state, action) => action.payload,
    },[]);
        